$(document).ready(function () {
    var toggle = $(".nav-btn");
    var table_menu = $(".menu_rows");
    var header = $(".header");

    // var blur = $('#blur');

    function updateMenuHeight() {
        var headHe = $(".header").outerHeight(true);
        var Mhe = "calc(100vh - " + headHe + "px)";
        $(".header .menu_modele").css("max-height", Mhe);
    }

    updateMenuHeight();

    $(window).resize(function () {
        updateMenuHeight();
    });

    toggle.on("click", function (e) {
        $(this).toggleClass("menu-btn-active");
        header.toggleClass("active");

        if (toggle.hasClass("menu-btn-active")) {
            table_menu.addClass("open");
        } else {
            table_menu.removeClass("open");
            $(".sub_menu").removeClass("open");
            $(".menu_btn").removeClass("active");
            // blur.css('display', 'none');
        }
    });

    // blur.click(function(event) {
    //     $('.sub_menu').removeClass('open');
    //     $('.menu_btn').removeClass('active');
    //     header.removeClass('active');
    //     blur.css('display', 'none');
    // });
    $(".menu_btn").click(function (event) {
        var isActive = $(this).hasClass("active");
        $(".menu_btn").removeClass("active");

        if (!isActive) {
            $(this).addClass("active");
        }
    });

    let isOpen = false;
    $(".menu_btn").click(function (event) {
        $(".sub_menu").removeClass("open");
        var activeBtn = $(this).hasClass("active");

        if (activeBtn) {
            $("." + $(this).attr("target")).addClass("open");
        }

        if ($(this).attr("target") === "menu_modele ") {
            if (!isOpen) {
                $("." + $(this).attr("target")).addClass("open");
                $(this).addClass("active");
                isOpen = true;
            } else {
                $("." + $(this).attr("target")).removeClass("open");
                $(this).removeClass("active");
                isOpen = false;
            }
        }

        if ($(".sub_menu").hasClass("open")) {
            header.addClass("active");
            // blur.css('display', 'block');
        } else {
            header.removeClass("active");
            // blur.css('display', 'none');
        }
    });

    $(".BacktoMenu").click(function (event) {
        $(".sub_menu").removeClass("open");
        table_menu.toggleClass("open");
        $(".menu_btn").removeClass("active");
    });

    $(".nav_model_btn").click(function (event) {
        $(".nav_model_btn").removeClass("active");
        $(this).addClass("active");
        $(".slider_model").css("display", "none");
        $("." + $(this).attr("data-view")).css("display", "block");
    });

    if ($("#referenceBlock").length > 0) {
        const $referenceBlock_a = $("#referenceBlock");
        const $movingBlock_a = $(".ul_poznaj");

        function updateMovingBlockPosition_a() {
            const referenceOffset = $referenceBlock_a.offset().left;

            $movingBlock_a.css("transform", `translateX(${referenceOffset}px)`);
        }

        $(window).resize(updateMovingBlockPosition_a);

        updateMovingBlockPosition_a();
    }

    if ($("#referenceBlock2").length > 0) {
        const $referenceBlock_a = $("#referenceBlock2");
        const $movingBlock_a = $(".ul_serwis");

        function updateMovingBlockPosition_a() {
            const referenceOffset = $referenceBlock_a.offset().left;

            $movingBlock_a.css("transform", `translateX(${referenceOffset}px)`);
        }

        $(window).resize(updateMovingBlockPosition_a);

        updateMovingBlockPosition_a();
    }

    $(".open_modal , .open_testdrive_modal , .BacktoMenu").click(function (
        event
    ) {
        event.preventDefault();
    });

    //____________FOOTER_START__________

    $(".title").click(function () {
        var imgRotate = $("." + $(this).attr("target"));
        imgRotate.toggleClass("rotate");
    });

    //____________FOOTER_END____________
    if ($("#model_slider").length > 0) {
        var model_slider = tns({
            container: "#model_slider",
            items: 1,
            swipeAngle: 60,
            loop: false,
            controls: true,
            speed: 400,
            navContainer: ".nav_model_slider",
            prevButton: ".nav__model_prev",
            nextButton: ".nav__model_next",
            responsive: {
                640: {
                    items: 2,
                },
                1100: {
                    items: 3,
                },
                1400: {
                    items: 3,
                },
                1600: {
                    items: 3,
                },
            },
        });
    }

    if ($("#OfroadSlider").length > 0) {
        var model_slider = tns({
            container: "#OfroadSlider",
            items: 1,
            swipeAngle: 60,
            loop: false,
            controls: true,
            speed: 400,
            navContainer: ".OR_nav_slider",
            prevButton: ".OR_nav_prev",
            nextButton: ".OR_nav_next",
            responsive: {
                640: {
                    items: 2,
                },
                1100: {
                    items: 3,
                },
                1400: {
                    items: 3,
                },
                1600: {
                    items: 3,
                },
            },
        });
    }

    if ($("#modelSliderSuv").length > 0) {
        var modelSliderSuv = tns({
            container: "#modelSliderSuv",
            items: 1,
            swipeAngle: 60,
            loop: false,
            controls: true,
            speed: 400,
            navContainer: ".suv_nav_slider",
            prevButton: ".suv_nav_prev",
            nextButton: ".suv_nav_next",
            responsive: {
                640: {
                    items: 2,
                },
                1100: {
                    items: 3,
                },
                1400: {
                    items: 3,
                },
                1600: {
                    items: 3,
                },
            },
        });
    }
    if ($("#modelSliderOfroad").length > 0) {
        var modelSliderEV = tns({
            container: "#modelSliderOfroad",
            items: 1,
            swipeAngle: 60,
            loop: false,
            controls: true,
            speed: 400,
            navContainer: ".ofroad_nav_slider",
            prevButton: ".ofroad_nav_prev",
            nextButton: ".ofroad_nav_next",
            responsive: {
                640: {
                    items: 2,
                },
                1100: {
                    items: 3,
                },
                1400: {
                    items: 3,
                },
                1600: {
                    items: 3,
                },
            },
        });
    }

    /*________LAST_BLOCK_SLIDER___*/
    if ($("#lastblockSlider").length > 0) {
        var model_last_slider = tns({
            container: "#lastblockSlider",
            items: 1,
            swipeAngle: 60,
            loop: true,
            nav: false,
            mouseDrag: true,
            controls: false,
            speed: 400,
            gutter: 25,
            slideBy: 1,
            responsive: {
                320: {
                    items: 1,
                    edgePadding: 100,
                },
                448: {
                    items: 1,
                    edgePadding: 130,
                },
                600: {
                    items: 2,
                    edgePadding: 100,
                },
                700: {
                    items: 2,
                    edgePadding: 120,
                },
                760: {
                    items: 2,
                    edgePadding: 140,
                },
                900: {
                    items: 3,
                    edgePadding: 120,
                },
                993: {
                    items: 3,
                    loop: false,
                    edgePadding: 100,
                },
                1200: {
                    items: 3,
                    loop: false,
                    edgePadding: 100,
                },
                1400: {
                    items: 3,
                    loop: false,
                    edgePadding: 80,
                },
                1600: {
                    items: 3,
                    loop: false,
                    edgePadding: 50,
                },
            },
        });
    }
    /*LAST BLOCK SLIDER BJ __*/
    if ($("#lastblockSliderBJ").length > 0) {
        var model_last_slider_bj = tns({
            container: "#lastblockSliderBJ",
            items: 1,
            swipeAngle: 60,
            loop: true,
            nav: false,
            mouseDrag: true,
            controls: false,
            speed: 400,
            gutter: 25,
            slideBy: 1,
            responsive: {
                320: {
                    items: 1,
                    edgePadding: 100,
                },
                448: {
                    items: 1,
                    edgePadding: 130,
                },
                600: {
                    items: 2,
                    edgePadding: 100,
                },
                700: {
                    items: 2,
                    edgePadding: 120,
                },
                760: {
                    items: 2,
                    edgePadding: 140,
                },
                900: {
                    items: 2,
                    edgePadding: 120,
                },
                993: {
                    items: 2,
                    loop: false,
                    edgePadding: 100,
                },
                1200: {
                    items: 3,
                    loop: false,
                    edgePadding: 100,
                },
                1400: {
                    items: 3,
                    loop: false,
                    edgePadding: 80,
                },
                1600: {
                    items: 3,
                    loop: false,
                    edgePadding: 50,
                },
            },
        });
    }

    /*___LAST_BLOCK_SLIDER__END__*/

    if ($("#introSlider").length > 0) {
        var intro_slider = tns({
            container: "#introSlider",
            autoplay: true,
            items: 1,
            touch: true,
            loop: true,
            nav: false,
            swipeAngle: 45,
            autoplayButtonOutput: false,
            controls: true,
            speed: 500,
        });


        let indexVideo = $("#indexVideo")[0];
        let customTimeoutActive = false;
        var customTimeout = function(info) {
            const currentIndex = info.displayIndex;

            if (currentIndex === 2)
                pauseSlide();
            else{
                indexVideo.pause();
                indexVideo.currentTime = 0;
            }
        }

        //pauseSlide();
        intro_slider.events.on('indexChanged', customTimeout);

        function pauseSlide(){
            customTimeoutActive = true;
            intro_slider.pause();
            indexVideo.play();

            setTimeout(() => {
                customTimeoutActive = false;
                intro_slider.goTo('next');
                intro_slider.play();
            }, 32000);
        }

    }

    /*__SECOND_BLOCK___START___*/
    if ($("#checkModelSlider").length > 0) {
        var slider_checkModel = tns({
            container: "#checkModelSlider",
            items: 1,
            swipeAngle: "45",
            slideBy: "page",
            loop: true,
            nav: true,
            controls: true,
            mode: "gallery",
            navContainer: ".check_model_nav",
            prevButton: ".check_model_left",
            nextButton: ".check_model_right",
            speed: 600,
            responsive: {
                998: {
                    controls: false,
                },
            },
        });
    }
    var changeHref = function (info, eventName) {
        setTimeout(async function () {
            var activeSlide = $("#checkModelSlider .tns-slide-active");
            var infoPriceTxt = $(".index_model_price");
            var plnBrutto = $(".no_wrap");
            var txtOD = $(".txt_od");

            if (activeSlide.length > 0) {
                var targetClass = activeSlide.attr("target");

                var poznaj = $("#check_more");
                var Zapytaj = $("#check_details");
                var modelTitle = $(".title_model");
                var priceModel = $(".indexPrice");
                var testdriveModalBtn = $("#testdriveModalBtn");

                var btnTestdrivDisplay;
                var infoTxtWkrótce;
                var hrefPoznaj;
                var title;
                var Price;
                var PlnBruttoCar;
                var dopisOD;

                switch (targetClass) {
                    case "check_eu5":
                        hrefPoznaj = "/baic-eu5";
                        Price = "WKRÓTCE";
                        title = "EU5";
                        btnDisplay = "none";
                        PlnBruttoCar = " ";
                        dopisOD = "";
                        break;
                    case "check_x55":
                        hrefPoznaj = "/baic-5";
                        Price = (await $.getJSON(`/calculator/models/5`).then(data => data))['base_price_brutto'];
                        title = "BAIC 5";
                        btnDisplay = "block";
                        btnTestdrivDisplay = "block";
                        PlnBruttoCar = "PLN BRUTTO"; /*pln brutto*/
                        dopisOD = " OD ";
                        break;
                    case "check_x35":
                        hrefPoznaj = "/baic-3";
                        Price = (await $.getJSON(`/calculator/models/3`).then(data => data))['base_price_brutto'];
                        title = "BAIC 3";
                        btnDisplay = "block";
                        btnTestdrivDisplay = "block";
                        PlnBruttoCar = "PLN BRUTTO";
                        dopisOD = " OD ";
                        break;
                    case "check_x7":
                        hrefPoznaj = "/baic-7";
                        Price = (await $.getJSON(`/calculator/models/7`).then(data => data))['base_price_brutto'];
                        title = "BAIC 7";
                        btnDisplay = "block";
                        btnTestdrivDisplay = "block";
                        PlnBruttoCar = "PLN BRUTTO";
                        dopisOD = " OD ";
                        break;
                    case "check_u5plus":
                        hrefPoznaj = " ";
                        Price = "WKRÓTCE";
                        title = "U5 PLUS";
                        btnDisplay = "none";
                        PlnBruttoCar = " ";
                        dopisOD = "";
                        break;
                }

                poznaj.attr("href", hrefPoznaj);
                poznaj.css("display", btnDisplay);

                modelTitle.fadeOut(0, function () {
                    plnBrutto.html(PlnBruttoCar);
                    txtOD.html(dopisOD);
                    priceModel.html(Price);
                    modelTitle.html(title);
                    modelTitle.fadeIn(50);
                    testdriveModalBtn.css("display", btnTestdrivDisplay);
                });
            }
        }, 100);
    };
    if ($("#checkModelSlider").length > 0) {
        slider_checkModel.events.on("transitionStart", changeHref);
    }

    $(".btn_change").click(function (event) {
        $(".btn_change").removeClass("active");
        $(this).addClass("active");
        $(".model_img_color").css("display", "none");
        $("." + $(this).attr("target")).css("display", "block");
    });

    if ($("#dealerBlockSlider").length > 0) {
        var promotionSlider = tns({
            container: "#dealerBlockSlider",
            items: 1,
            swipeAngle: 60,
            mouseDrag: true,
            loop: false,
            navContainer: ".dealerBlockSlider_nav",
            gutter: 20,
            controls: false,
            speed: 400,
            responsive: {
                640: {
                    nav: false,
                    items: 2,
                },
            },
        });
    }

    const firstBtnId = $(".dealer_details_btn").first().attr("id");
    $(".dealer_details_btn").first().addClass("active");

    $(".dealer_department").each(function () {
        if ($(this).hasClass(firstBtnId)) {
            $(this).show();
        } else {
            $(this).hide();
        }
    });
    $(".dealer_details_btn").click(function () {
        // Remove the 'active' class from all buttons
        $(".dealer_details_btn").removeClass("active");
        // Add the 'active' class to the clicked button
        $(this).addClass("active");
        const btnId = $(this).attr("id");

        // Rest of your code

        $(".dealer_department").each(function () {
            if ($(this).hasClass(btnId)) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    });

    $("#dealersDataList").on("input", function () {
        var userText = $(this).val();
        $("#dealersOptions")
            .find("option")
            .each(function () {
                if ($(this).val() === userText) {
                    $("#serviceDataList").val("");
                    $(".dealer-box").hide();
                    var dealerId = $(this).attr("data-id");
                    $("#dealer" + dealerId).show();
                    if (markers[dealerId]) {
                        google.maps.event.trigger(markers[dealerId], "click");
                    }
                }
            });
    });

    $("#serviceDataList").on("input", function () {
        var userText = $(this).val();
        $("#serwisOptions")
            .find("option")
            .each(function () {
                if ($(this).val() === userText) {
                    $(".dealer-box").hide();
                    $("#dealersDataList").val("");
                    var serviceId = $(this).attr("data-id");
                    $("#dealer" + serviceId).show();
                    if (markers[serviceId]) {
                        google.maps.event.trigger(markers[serviceId], "click");
                    }
                }
            });
    });

    if ($("#promotionSlider").length > 0) {
        var promotionSlider = tns({
            container: "#promotionSlider",
            items: 1,
            swipeAngle: 60,
            loop: true,
            nav: false,
            controls: true,
            speed: 400,
            prevButton: ".promotionSlider_prev",
            nextButton: ".promotionSlider_next",
            responsive: {
                640: {
                    items: 1,
                },
                998: {
                    gutter: 20,
                    items: 2,
                },

                1410: {
                    gutter: 20,
                    items: 3,
                },
            },
        });
    }

    /*INDEX_BLOCK_3*/
    // var txtB3 = $('#title_b3');
    // var IndexTechnologiePos = $('#indexTechnologies');

    // if ($("#title_b3").length > 0) {
    //     $(window).scroll(function() {
    //         var loc = IndexTechnologiePos.offset().top;
    //         var scrollLoc = $(window).scrollTop() + $(window).height() / 2;

    //         if (scrollLoc > loc) {
    //             txtB3.addClass('show');
    //         }
    //            });
    // }

    //Footer______START___!
    $(".title").click(function () {
        var imgRotate = $("." + $(this).attr("target"));
        imgRotate.toggleClass("rotate");
    });

    is_calculator = false;
    $(".open_modal").click(function () {
        if ($(this).hasClass("is_calculator")) {
            is_calculator = true;
        }
        $("#contact_modal").modal("show");

        if (window.location.href.includes('bmg.sopot')) {
            var axel = Math.random() + "";
            var a = axel * 10000000000000;
            $('body').prepend('<iframe src="https://11627135.fls.doubleclick.net/activityi;src=11627135;type=baics0;cat=baic_000;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=' + a + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>');
        }

        var identifier = $(this).data("id");
        var nameModel = $(this).data("name");

        if (nameModel !== undefined) {
            setTimeout(function () {
                $('#inputModel option[data-identifier="' + identifier + '"]')
                    .prop("selected", true)
                    .change();
                $("#contact_modal")
                    .find("#formContactQuestion")
                    .val("Jestem zainteresowany ofertą na model " + nameModel);
            }, 400);
        } else {
            $("#contact_modal").find("#formContactQuestion").val("");
        }
    });

    // Obsługa kliknięcia w elementach .open_testdrive_modal, obsługa zdarzeń dla dynamicznie tworzonych elementów
    $(document).on("click", ".open_testdrive_modal", async function () {
        var dataValue = $(this).attr("data-department-id");
        if (dataValue !== undefined && dataValue !== "") {
            await $.ajax({
                _token: $('#token').val(),
                url: '/get_dealers',
                type: 'GET',
            }).then(function (dealers) {
                $(".select_dealer_txt").addClass("active");
                setTimeout(function () {
                    let dealerInput = $("#inputDealerTestDrive");
                    dealerInput.find('option').remove();
                    let dealer = dealers.find(d => d.department_autobahn_branch_id == dataValue)
                    dealerInput.append(`<option value="${dealer.department_autobahn_branch_id}">${dealer.department_city} ${dealer.department_name}</option>`);
                },1000)

            });
        }
        $("#testdrive_modal").modal("show");
        if (window.location.href.includes('bmg.sopot')) {
            var axel = Math.random() + "";
            var a = axel * 10000000000000;
            $('body').prepend('<iframe src="https://11627135.fls.doubleclick.net/activityi;src=11627135;type=baics0;cat=baic_002;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;npa=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755};ord=' + a + '?" width="1" height="1" frameborder="0" style="display:none"></iframe>');
        }
    });

    $(".open_modalVisitService").click(function () {
        $("#visitServiceModal").modal("show");
    });

    $(".open_modalAirConditioning").click(function () {
        $("#visitAirConditioningModal").modal("show");
    });

    /*RIGHT_BAR_START*/
    $(".open_card").click(function () {
        $(".card_nav").toggleClass("active");
        $(".open_card span").toggleClass("active");
        $(".in_krt").toggleClass("open");
    });

    //RIGHT_BAR , FOOTER____END__!

    $("#read-more-assistance").click(function () {
        if ($(".assistance-cookies").hasClass("d-none")) {
            $(".assistance-cookies").removeClass("d-none");
            $("#read-more-assistance").addClass("main_color");
            $(".read-more-arrow").addClass("bi-chevron-up");
            $(".read-more-arrow").removelass("bi-chevron-down");
        } else {
            $(".assistance-cookies").addClass("d-none");
            $("#read-more-assistance").removeClass("main_color");
            $(".read-more-arrow").removeClass("bi-chevron-up");
            $(".read-more-arrow").addClass("bi-chevron-down");
        }
    });
});

$(document).ready(function () {
    if (window.location.pathname === "/historia") {
        $("a#referenceBlock").addClass("active-lnk");
    }
    if (window.location.pathname === "/technologia") {
        $("a#technology").addClass("active-lnk");
    }
    if (window.location.pathname === "/dealerzy") {
        $("a#dealers").addClass("active-lnk");
    }
    if (window.location.pathname === "/kontakt") {
        $("a#contact").addClass("active-lnk");
    }
    if (window.location.pathname === "/serwis") {
        $("a#service").addClass("active-lnk");
    }

    if (window.location.pathname === "/baic-3") {
        $("a#modele_m").addClass("active-lnk");
    }
    if (window.location.pathname === "/baic-5") {
        $("a#modele_m").addClass("active-lnk");
    }
    if (window.location.pathname === "/baic-7") {
        $("a#modele_m").addClass("active-lnk");
    }
    if (window.location.pathname === "/bj-40") {
        $("a#modele_m").addClass("active-lnk");
    }
    if (window.location.pathname === "/bj-60") {
        $("a#modele_m").addClass("active-lnk");
    }

    if (window.location.pathname.includes("/formularz-jazda-probna")) {
        // $('#testdrive_modal').modal('show');
        setTimeout(function () {
            $(".open_testdrive_modal").click();
        }, 1000);
    }

    if (window.location.pathname.includes("/formularz-zapytaj-o-oferte")) {
        setTimeout(function () {
            $(".open_modal").click();
        }, 1000);
    }

    $(document).on("shown.bs.modal", ".ajaxModal", function (e) {
        const modal = e.target;
        const url = modal.dataset.url;
        let message = "";
        $(modal).find(".modal-content .modal-body").html("");
        if ($(".btn_change_calc.active").length && is_calculator) {
            const info = new Array();
            info.push("Mój kalkulator to:");
            info.push("");
            info.push(
                "Typ Kredytu: " + $(".btn_change_calc.active").html().trim()
            );
            info.push(
                "" +
                $(".calculator.open .index_model_price")
                    .text()
                    .replace(/\s\s+/g, " ")
                    .trim()
            );
            // info.push('RRSO: ' + $('#monthlyRRSOCredit').html().trim());
            info.push(
                "Okres (miesiące): " +
                $(".calculator.open .months_count").text().trim()
            );
            info.push(
                "Wpłata własna: " +
                $(".calculator.open .payment_own").text().trim()
            );
            info.push("Cena bazowa: " + $("#basicPrice").text().trim());
            message = info.join("\n");
            console.log(message);
        }
        $.get(
            url,
            {current_url: window.location.pathname, message: message},
            function (response) {
                $(modal).find(".modal-content .modal-body").html(response);
                select2Init();
                is_calculator = false;
            }
        ).fail(function () {
            alert("error");
        });
    });
});
$(document).ready(function () {
    if ($("#news_show_slider").length > 0) {
        var slider_news = tns({
            container: "#news_show_slider",
            items: 2,
            touch: false,
            nav: false,
            gutter: 30,
            controls: true,
            autoplay: true,
            autoplayButtonOutput: false,
            prevButton: ".news_show_slider_prev",
            nextButton: ".news_show_slider_next",
            responsive: {
                767: {
                    items: 3,
                },
                991: {
                    items: 2,
                },
                1400: {
                    items: 3,
                },
            },
            speed: 400,
        });

        var changeImg = function (info, eventName) {
            var activeSlide = $("#news_show_slider .tns-slide-active").eq(0);
            var ShowImg = activeSlide.find("img").attr("src");
            $("#showNewsImg").attr("src", ShowImg);
            $("#showNewsLink").attr("href", ShowImg);
        };
        changeImg();

        slider_news.events.on("transitionStart", changeImg);
    }

    if ($("#newsSlider").length) {
        var newsSlider = tns({
            container: "#newsSlider",
            items: 1,
            slideBy: 1,
            loop: true,
            nav: false,
            gutter: 20,
            // edgePadding: 70,
            controls: true,
            prevButton: ".newsSlider_prev",
            nextButton: ".newsSlider_next",
            responsive: {
                650: {
                    items: 2,
                    // edgePadding: 150,
                    gutter: 30,
                },
                1400: {
                    items: 2,
                },
            },
            speed: 400,
            // onInit: updateOpacity,
        });

        // function updateOpacity() {
        //     const opacitySlide = $("#newsSlider .tns-item");
        //     opacitySlide.css("opacity", 1);

        //     const activeSlides = $("#newsSlider .tns-item.tns-slide-active");
        //     activeSlides.eq(0).css("opacity", 0.5);
        //     activeSlides.eq(activeSlides.length - 1).css("opacity", 0.5);
        // }
        // newsSlider.events.on("transitionStart", updateOpacity);

        var sliderHeight = $("#newsSlider").outerHeight();
        $("#newsSlider .news_slide").css("min-height", sliderHeight + "px");
    }

    $(".model_card_price_list").on("click", function () {
        if ($(this).attr("is_chosen") === "1")
        {
            $(".price_list_row").css("display", "flex");
            $(".model_card_price_list").css("opacity", 1);
            $(this).removeAttr("is_chosen");
        }
        else
        {
            $(".price_list_row").css("display", "none");
            $(".price_list_row_"+$(this).attr("data-name")).css("display", "flex");
            $(".model_card_price_list").css("opacity", 0.7);
            $(".model_card_price_list").removeAttr("is_chosen");
            $(this).css("opacity", 1);
            $(this).attr("is_chosen", 1);
            if (window.outerWidth < 991)
            {
                $(".price_list_row_"+$(this).attr("data-name")).get(0).scrollIntoView({behavior: 'instant'});
                setTimeout(()=>window.scrollBy(0,-60),0);
            }
        }
    })
});
